import { environment } from '../environments/environment';

export const AppConfig = {
  apiUrl: environment.apiUrl,
  google: environment.google,
  stripe: environment.stripe
};



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/app.config.ts